module.exports = __webpack_public_path__ + "img/img-online-step-02.png";